import { prop } from 'ramda';
import { useEffect } from 'react';

import { useAppSelector } from 'js/store/hooks';

const clearThemeNameClass = () => {
    document.body.classList.forEach((className) => {
        if (/^theme-name-/.test(className)) {
            document.body.classList.remove(className);
        }
    });
};

export const useThemeNameClass = () => {
    const themeName = useAppSelector(prop('themeName'));

    useEffect(() => {
        if (!themeName) {
            return;
        }

        document.body.classList.add(`theme-name-${themeName}`);

        return () => {
            clearThemeNameClass();
        };
    }, [themeName]);
};
